import { FC } from 'react';

import styles from './Description.module.scss';

interface DescriptionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: string;
}

const Description: FC<DescriptionProps> = ({ children, ...props }) => {
  return (
    <div className={styles.description} {...props}>
      {children}
    </div>
  );
};

export default Description;
